(function () {
  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function getTargetDate(mode, timerText) {
    const now = new Date();

    switch (mode) {
      case 'day':
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      case 'week': {
        let daysUntilNextMonday = (8 - now.getDay()) % 7;
        if (daysUntilNextMonday === 0) {
          daysUntilNextMonday = 7;
        }

        const targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilNextMonday);
        targetDate.setHours(0, 0, 0, 0);
        return targetDate;
      }
      case 'month':
        return new Date(now.getFullYear(), now.getMonth() + 1, 1);
      case 'date':
      default: {
        const targetDate = new Date(timerText);

        if (!Number.isNaN(targetDate.getTime()) && targetDate > now) {
          return targetDate;
        }

        const fallbackDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        fallbackDate.setHours(0, 0, 0, 0);
        return fallbackDate;
      }
    }
  }

  function updateCountdown(countdown) {
    const hoursEl = countdown.querySelector('[data-timer-hours]');
    const minutesEl = countdown.querySelector('[data-timer-minutes]');
    const secondsEl = countdown.querySelector('[data-timer-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    const targetDate = getTargetDate(countdown.dataset.timerMode, countdown.dataset.timerText);
    const timeDifference = targetDate - new Date();

    if (timeDifference <= 0) {
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return;
    }

    const totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    hoursEl.textContent = pad(totalHours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  }

  function initSection(section) {
    const countdowns = section.querySelectorAll('.et-bundle-timer__countdown');

    countdowns.forEach(function (countdown) {
      if (countdown.dataset.initialized === 'true') {
        return;
      }

      countdown.dataset.initialized = 'true';
      updateCountdown(countdown);

      window.setInterval(function () {
        updateCountdown(countdown);
      }, 1000);
    });
  }

  function initAll() {
    document.querySelectorAll('.et-bundle-timer').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.et-bundle-timer');
    if (section) {
      initSection(section);
    }
  });
})();
